import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import Container from '../Container';
import Button from '../Button';

import styles from './contact-success.css';

const { div, h1, p } = hh(h);

const ContactSuccess = () => (
    h(Container, {theme: 'five'}, [
        div({className: styles.container}, [
            h1({className: styles.title}, 'Thanks for submitting your interest!'),
            p({className: styles.message}, 'We’ll get back to you as soon as possible.'),
            h(Button, {arrow: true, arrowPosition: 'back', href: '/', size: 'medium'}, ['Back to the site'])])])
);

export default ContactSuccess;



/** WEBPACK FOOTER **
 ** ./src/ContactSuccess/index.js
 **/